import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormBuilder, FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../services/user.service';
import { AjaxService } from '../services/ajax.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-annula-data-target',
  standalone: true,
  imports: [CommonModule, TextFieldModule, ReactiveFormsModule],
  templateUrl: './annula-data-target.component.html',
  styleUrl: './annula-data-target.component.scss'
})
export class AnnulaDataTargetComponent {

  dataForm: FormGroup;
  rows: number[] = [];
  schoolId : number = 0;
  defaultADT : string = ''
  userSubscription: Subscription[] = [];

  constructor(private fb : FormBuilder, private _userService:UserService, private _ajaxService : AjaxService, public _snackbar : MatSnackBar) {
    this.dataForm = this.fb.group({
      inputDataArray: this.fb.array([])
    });
    
  }

  ngOnInit() {
    this.userSubscription.push(this._userService.getSchoolId().subscribe(value => {
      if (value) this.schoolId = value
      this.getAnnualData();
    }))
  }

  get inputDataArray(): FormArray {
    return this.dataForm.get('inputDataArray') as FormArray;
  }

  addInput() {
    this.inputDataArray.push(this.fb.control(''));
    this.rows.push(1)
  }

  saveData() {
    let request = {
      "schoolId": this.schoolId,
      "additionalADT" : this.dataForm.value.inputDataArray
    }
    this._ajaxService.post('adt/saveAdt', request).then((response: any) => {
      if (response.statusCode == 200) {
        this.getAnnualData();
        this._snackbar.open("Annual Data Target Updated Successfully", "OK", { duration: 3000, panelClass: "warning-success" });
      }
    })
  }

  removeItem(idx: number): void {
    this.inputDataArray.removeAt(idx);
    this.rows = this.rows.filter((row, index) => index !== idx)
    this.saveData();
  }

  getAnnualData() {
    this._ajaxService.get(`adt/getAdt/${this.schoolId}`).then((response: any) => {
      if (response.statusCode == 200) {
        this.inputDataArray.clear();
        this.rows = []
        if (response.data.length > 0 && response.data[0].defaultAdt) this.defaultADT = response.data[0].defaultAdt;
        if (response.data.length > 0 && response.data[0].additionalAdt) {
          const updatedData = response.data[0].additionalAdt.replace(/\n/g, "\\n");
          JSON.parse(updatedData).map((adt : any) => {
            this.inputDataArray.push(this.fb.control(adt))
            let row = adt.split('\n').length;
            this.rows.push(row+2)
          })
        }
      }
    })
  }

  ngOnDestroy(): void {
    this.userSubscription.forEach(sub => sub.unsubscribe());
  }

}
